import axios from "axios";

// One account's statement (a deposit, a share account or a loan) for a date
// range: the JSON shape for the screen, and the PDF variant fetched as a
// blob so AccountStatement.vue can save it without touching the response
// envelope helpers (the PDF route returns raw bytes, not {message, data}).
export default {
  namespaced: true,

  state: {
    statement: null,
  },

  getters: {
    statement(state) {
      return state.statement;
    },
  },

  mutations: {
    SET_STATEMENT(state, statement) {
      state.statement = statement;
    },
  },

  actions: {
    async fetchAccountStatement({ commit }, { accountType, accountId, from, to }) {
      // the store is shared across accounts: never leave the previous
      // account's statement on screen while this one loads, or after a failure
      commit("SET_STATEMENT", null);
      return await axios
        .get(`/api/v1/statements/${accountType}/${accountId}`, {
          params: { from, to },
        })
        .then((res) => {
          commit("SET_STATEMENT", res.data.data);
          return res.data;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },

    async fetchAccountStatementPdf({ commit }, { accountType, accountId, from, to }) {
      return await axios
        .get(`/api/v1/statements/${accountType}/${accountId}/pdf`, {
          params: { from, to },
          responseType: "blob",
        })
        .then((res) => res.data)
        .catch((err) => {
          return Promise.reject(err);
        });
    },
  },
};
